import { render, staticRenderFns } from "./PaquetesPrecioCRUD.vue?vue&type=template&id=4da48bd8"
import script from "./PaquetesPrecioCRUD.vue?vue&type=script&lang=js"
export * from "./PaquetesPrecioCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports